import { type CSSProperties, useEffect, useRef, useState } from "react";
import useResizeObserver from "use-resize-observer";

import { type CalculatePositionType, QuickRankDestination } from "../Destination";
import { QuickRankRenderableDestinations } from "../../../../reducers/quickrank";
import { useQuickRankDestinations } from "../../../../hooks/quickrank/useQuickRankDestinations";

import styles from "./Deck.module.scss";

export const QuickRankDeck = () => {
  const ref = useRef<HTMLDivElement>(null);
  const { toRender } = useQuickRankDestinations().refs.deck;
  const [calculatePosition, setCalculatePosition] = useState<CalculatePositionType | undefined>(undefined);

  const { width, height } = useResizeObserver<HTMLDivElement>({ ref });

  useEffect(() => {
    setCalculatePosition(() => (index: number) => {
      const style: CSSProperties = { top: "0px", right: "0px" };
      const wrapperEl = ref?.current;

      if (!wrapperEl) {
        return style;
      }

      const firstChild = wrapperEl.children[0];

      if (!firstChild) {
        return style;
      }

      const { height: destinationHeight, width: destinationWidth } = firstChild.getBoundingClientRect();
      const { height: wrapperHeight, width: wrapperWidth } = wrapperEl.getBoundingClientRect();
      const top = ((wrapperHeight - destinationHeight) / toRender) * index;
      const right = ((wrapperWidth - destinationWidth) / toRender) * index;
      style.top = `${top}px`;
      style.right = `${right}px`;
      style.zIndex = 500 - index;

      return style;
    });
  }, [width, height]);

  return (
    <QuickRankDestination
      kind={QuickRankRenderableDestinations.DECK}
      ref={ref}
      calculatePosition={calculatePosition}
      styles={styles}
    />
  );
};
